export default __webpack_public_path__ + "static/media/ColagemAureanos2.169e8916.png";